let endpointUrl = 'http://localhost/xwiki';
let xWikiUrl = 'http://localhost/xwiki';
let options = {endpointUrl, credentials: 'include', mode: 'cors'};

/** Параметр, содержащий адрес сервера WebProteget */
const xwiki_server_url = "xwiki.server.url";
const id_settings = "settings";

/** В HTML странице должен быть элемент с id_settings, в котором атрибут xwiki.server.url содержит адрес xWiki сервера
 *  например  <div class="display: none;" id="settings"
 *   xwiki.server.url="https://stat.semanticpro.org/xwiki"></div>
 */
const loadXWikiSettings = settings =>{
	const node = document.getElementById(id_settings);
	if (!node){
		alert("Параметры соединения c XWiki отсутствуют!\nБудут использованы настройки по умолчанию!\nОбратитесь к администратору системы.")
		return;
	}
    if (node.getAttribute(xwiki_server_url)==null){
		console.warn("XWiki url server not setting ("+xwiki_server_url+" not found)!");
	} else {
        settings.xWikiUrl = node.getAttribute(xwiki_server_url);
        settings.endpointUrl = node.getAttribute(xwiki_server_url);
        settings.options.endpointUrl = node.getAttribute(xwiki_server_url);
    }
    console.log("XWiki settings", settings);
	return settings;
}

let settings = loadXWikiSettings({
    xWikiUrl,           //Адрес к xWiki,    например https://stat.semanticpro.org/xwiki
    endpointUrl,        //Адрес к REST API, например https://stat.semanticpro.org/xwiki
    loadTimeout: 300000,
    DATE_TIME_FORMAT: 'DD.MM.YYYY HH:mm',
    DATE_FORMAT: 'DD.MM.YYYY',
    defaultLocale: 'ru',
    xwiki_username: 'xrest',
    xwiki_password: 'passw0rd',
    options
});

export default settings;
